import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbModule } from './bread-crumb/bread-crumb.module';
import { ConditionalMatIconModule } from './conditional-mat-icon/conditional-mat-icon.module';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';
import { LoadingModule } from './loading/loading.module';
import { LoadingErrorModule } from './loading-error/loading-error.module';
import { NotFoundModule } from './not-found/not-found.module';
import { PathSelectorModule } from './bread-crumb/path-selector/path-selector.module';
import { PreparingModule } from './preparing/preparing.module';
import { SubToolbarModule } from './sub-toolbar/sub-toolbar.module';
import { ScrollIndicatorModule } from './scroll-indicator/scroll-indicator.module';
import { BannerModule } from './banner/banner.module';
import { CustomFavoriteNameDialogModule } from './custom-favorite-name-dialog/custom-favorite-name-dialog.module';
import { CloneFavoriteDialogModule } from './clone-favorite-dialog/clone-favorite-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        BreadCrumbModule,
        ConditionalMatIconModule,
        ConfirmDialogModule,
        CustomFavoriteNameDialogModule,
        CloneFavoriteDialogModule,
        LoadingModule,
        LoadingErrorModule,
        NotFoundModule,
        PathSelectorModule,
        PreparingModule,
        SubToolbarModule,
        ScrollIndicatorModule,
        BannerModule
    ],
    exports: [
        BreadCrumbModule,
        ConditionalMatIconModule,
        ConfirmDialogModule,
        LoadingModule,
        LoadingErrorModule,
        NotFoundModule,
        PathSelectorModule,
        PreparingModule,
        SubToolbarModule,
        ScrollIndicatorModule,
        BannerModule
    ]
})
export class CaslinkCommonComponentsModule {
}
